import type { MeResponse } from "../api/types";
import { hasPermission, isICRole } from "../auth/permissions";
import { Link } from "../router/Router";

export function ForbiddenPage({ me }: { me?: MeResponse } = {}) {
  const back = me === undefined ? null : friendlyBack(me);
  return (
    <div className="card empty-state">
      <h2>Not authorized</h2>
      <p>You're signed in, but your role doesn't have access to this area.</p>
      {back !== null && (
        <p>
          <Link to={back.to}>Back to {back.label}</Link>
        </p>
      )}
    </div>
  );
}

// friendlyBack picks a destination the current user can actually open. ICs
// land on the gumballs page; anyone with members:view goes to the People
// directory; everyone else falls back to the non-IC empty state on /gumballs.
function friendlyBack(me: MeResponse): { to: string; label: string } | null {
  if (isICRole(me)) {
    return { to: "/gumballs", label: "Gumballs" };
  }
  if (hasPermission(me, "members:view")) {
    return { to: "/admin/people", label: "People" };
  }
  return { to: "/gumballs", label: "Gumballs" };
}
